
import { Link } from "react-router-dom";
import SubsPromoCarousel from "../../components/items/SubsPromoCarousel";
import img from "../../assets/images/blog/icon/code.png";
const promoSlides = [
  {
    title: "أحصل على الموقع الجغرافي",
    description: "يمكنك معرفة موقع تواجد أي عضو من الأعضاء",
    img: img,
  },
  {
    title: "تغيير اسم المستخدم",
    description:
      "يمكنك تغيير اسم المستخدم الخاص بك والذي يظهر عند باقي الأعضاء",
    img: img,
  },
  {
    title: "التحكم بحالة اتصالك",
    description: "يمكنك تغيير حالة اتصالك بسهولة",
    img: img,
  },
  {
    title: "تغيير رسالة المستخدم ",
    description: "غير تفضيلاتك البلد المفضل الجنسية المفضلة",
    img: img,
  },
];
const Members = () => {
  return (
    <section className="work-section padding-tb">
      <div className="container">
        <div className="main-blog">
          <SubsPromoCarousel promoSlides={promoSlides} />
          <div className="member-button-group d-flex flex-wrap justify-content-center">
            <Link to="/subscriptions" className="lab-btn">
              <i className="icofont-users"></i>
              <span> تفاصيل الباقات </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Members;
